(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('policy-anag', {
            parent: 'app',
            url: '/policy-anag?page&sort&search',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY'],
                pageTitle: 'uniromaLandingApp.policyAnag.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/policy-anag/policies.html',
                    controller: 'PolicyAnagController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                	var searchParam = $stateParams.search ? JSON.parse($stateParams.search) : {};
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: searchParam
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('policyAnag');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('policy-anag-detail', {
            parent: 'policy-anag',
            url: '/policy-anag/{id}',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY'],
                pageTitle: 'uniromaLandingApp.policyAnag.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/policy-anag/policy-detail.html',
                    controller: 'PolicyAnagDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('policyAnag');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PolicyAnag', function($stateParams, PolicyAnag) {
                    return PolicyAnag.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'policy-anag',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('policy-anag-detail.edit', {
            parent: 'policy-anag-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-anag/policy-dialog.html',
                    controller: 'PolicyAnagDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PolicyAnag', function(PolicyAnag) {
                            return PolicyAnag.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('policy-anag.new', {
            parent: 'policy-anag',
            url: '/new',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-anag/policy-dialog.html',
                    controller: 'PolicyAnagDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                            	name: null,
                                priority: null,
                                id: null,
                                isActive: 0,
                                flInserimentoGuidato:false
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('policy-anag', null, { reload: 'policy-anag' });
                }, function() {
                    $state.go('policy-anag');
                });
            }]
        })
        .state('policy-anag.test', {
            parent: 'policy-anag',
            url: '/test',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-anag/test-policy-dialog.html',
                    controller: 'TestPolicyAnagDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('policy-anag', null, { reload: 'policy-anag' });
                }, function() {
                    $state.go('policy-anag');
                });
            }]
        })
        .state('policy-anag.edit', {
            parent: 'policy-anag',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-anag/policy-dialog.html',
                    controller: 'PolicyAnagDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PolicyAnag', function(PolicyAnag) {
                            return PolicyAnag.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('policy-anag', null, { reload: 'policy-anag' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('policy-anag.delete', {
            parent: 'policy-anag',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_GESTIONE_POLICY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-anag/policy-delete-dialog.html',
                    controller: 'PolicyAnagDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PolicyAnag', function(PolicyAnag) {
                            return PolicyAnag.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('policy-anag', null, { reload: 'policy-anag' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
